import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// Create a new artist
export const createArtist = createAsyncThunk(
  "artists/createArtist",
  async ({ token, payload }) => {
    const response = await api.post("/artists", { ...payload }, { token });
    return response.data;
  },
);

// Get all artists with optional query parameters
export const getAllArtists = createAsyncThunk(
  "artists/getAllArtists",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/artists", {
      token,
      params: queryParams,
    });
    return response.data;
  },
);

// Update an existing artist
export const updateArtist = createAsyncThunk(
  "artists/updateArtist",
  async ({ token, id, payload }) => {
    const response = await api.patch(
      `/artists/${id}`,
      { ...payload },
      { token },
    );
    return response.data;
  },
);

// Delete an artist by ID
export const deleteArtist = createAsyncThunk(
  "artists/deleteArtist",
  async ({ token, id }) => {
    const response = await api.delete(`/artists/${id}`, { token });
    return response.data;
  },
);
// Fetch artist details from Spotify
export const fetchArtistSpotifyDetails = createAsyncThunk(
  "artists/fetchSpotifyDetails",
  async ({ token, artistName }) => {
    const response = await api.post(
      "/artists/fetch-spotify-details",
      { artistName },
      { token },
    );
    return response.data;
  },
);

// Batch fetch artist details from Spotify.
// When pollJobId is provided, polls the job status endpoint instead of starting a new job.
export const batchFetchSpotifyArtists = createAsyncThunk(
  "artists/batchFetchSpotify",
  async ({ token, pollJobId, includeLogs }) => {
    if (pollJobId) {
      // Polling mode: GET job status
      const response = await api.get(
        `/artists/batch-fetch-spotify/status/${pollJobId}`,
        {
          token,
          params: includeLogs ? { includeLogs: "true" } : {},
        },
      );
      return response.data;
    }
    // Normal mode: start a new batch job
    const response = await api.post(
      "/artists/batch-fetch-spotify",
      {},
      { token },
    );
    return response.data;
  },
);
